import type { FaireProductEntity } from "../../entity_types/product";

export const p_vavga6v283: FaireProductEntity = {
  token: "p_vavga6v283",
  type: "product",
  name: "Saltwater Jasmine– Air Freshener",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6fea30570ee26039fc3e8bd202d86217469b79df6917b287b3021365781cf7a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9dd8e076010e44b5bd6ff39a97c86dd35b581ec80d3b8abeef4929a65b99cf21.jpeg",
    "https://cdn.faire.com/fastly/99c10b6c685ca0699d783e82c9cd458c4097db735a0e8b53194b1250b3bbc756.png",
    "https://cdn.faire.com/fastly/932736a7bfd74931998badf7e380927a4b35b94f19dcdd5667f212416c9ece69.jpeg",
    "https://cdn.faire.com/fastly/661a1ac751416560f4f206e7a451583d12bb7df3b39e9fa16f9dab1241913bdd.png",
  ],
  priceDollars: 5.5,
  description:
    "*NEW* Coastal mornings blanketed in a gentle marine layer, the warmth of the rising sun, wild white blossoms collecting dew. Ozonic, crisp, clean, with bergamot, muguet, sea moss, and sandalwood. \n\n Our best-selling 7.2 oz Standard Size. This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours. Coastal mornings blanketed in a gentle marine layer, the warmth of the rising sun, wild white blossoms collecting dew. Ozonic, crisp, clean, with bergamot, muguet, sea moss, and sandalwood. \n\nAir Fresheners are a flame-free collection designed to scent small spaces, like closets, bathrooms, gym lockers, trash cans, hotel rooms, and anywhere else that needs a little fragrance boost. \n\nThey are pre-packed in pairs, featuring an iconic P.F. Candle-shape and signature kraft paper look. Available in 8 best-selling Classic Line scents. ",
  tags: [],
  msrpDollars: 11.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:04.066Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
